import React, {Component} from 'react';
import {connect} from 'react-redux';
import {verifyLinkedAccountsRequest} from '../../actions/authActions';
import GuestLayout from "../Layout/GuestLayout";
import {getErrorMessage, trans} from "../../utils/helpers";
import {selectAuth, selectAccountInfo, selectErrorMessage, getUser} from '../../selectors';

class VerifyLinkAccount extends Component {
    state = {
        error: '',
        title: '',
        message: '',
        titleCompleted:'',
        messageCompleted:'',
        requestStarted: false,
        termsAccepted: false
    };

    componentDidMount(){

        (async() => {
            const title= await trans('en-us', 'verifyLinkAccountRequest.titleInProgress');
            const message= await trans('en-us', 'verifyLinkAccountRequest.messageInProgress');
            const titleCompleted= await trans('en-us', 'verifyLinkAccountRequest.titleCompleted');
            const messageCompleted= await trans('en-us', 'verifyLinkAccountRequest.messageCompleted');

            this.setState({title,message,titleCompleted,messageCompleted});
        })()
    }



    linkAccountAction = () => {
        this.setState({requestStarted: true}, this.startVerification)
    }
    startVerification = () => {

        if (!this.state.termsAccepted) {
            return;
        }

        const verificationToken = this.props.location.search.substring(7);
        this.props.verifyLinkedAccountsRequest(verificationToken, this.state.termsAccepted).then((response) => {
            if (response.success === true) {
                this.setState({
                    error: false,
                    title: this.state.titleCompleted,
                    message: this.state.messageCompleted,
                });
            } else {
                const errorMessage = getErrorMessage({data: response}, 'en-us');
                this.setState({
                    error: true,
                    message: errorMessage.message,
                });
            }
        });
    }

    render() {
        const {error, requestStarted, termsAccepted} = this.state;




        if (!requestStarted) {
            return (

                    <GuestLayout>
                    <div className="cp-page cp-page-login justify-content-start">
                        <div className="card-guest card-full-height text-secondary">
                            <div className="card-guest-header">
                            <div className="brand-container">
                            </div>
                            <p className="brand-header">Linked Account Request Verification</p>
                            </div>
                                <div >
                                    <p>Please accept our terms and conditions in order to verify linked account
                                        request.</p>
                                    <input
                                        type="checkbox"
                                        checked={this.state.termsAccepted}
                                        onChange={(e) => this.setState({termsAccepted: e.target.checked})}
                                    />
                                    <label className='ml-2'> I accept the terms and conditions</label>
                                </div>
                                <button className='btn btn-sm btn-primary mt-2' disabled={!this.state.termsAccepted}
                                        onClick={() => this.linkAccountAction()}>Link Account
                                </button>



                        </div>
                    </div>

                    </GuestLayout>


            );
        } else if (requestStarted && termsAccepted) {

            return (
                <GuestLayout>
                    <div className="cp-page cp-page-login justify-content-start">
                        <div className="card-guest card-full-height">
                            <div className="message">

                                <div
                                    className={"message-left" + (error === true ? ' text-danger' : (error === false ? '' : ' text-muted'))}>
                                    <i className={"fas fa-" + (error === true ? 'times' : (error === false ? 'check' : 'spinner fa-spin'))}></i>
                                </div>

                                <div className="message-right">
                                    <h4 className={(error === true ? ' text-danger' : (error === false ? '' : ' text-muted'))}>{this.state.title}</h4>
                                    <p>{this.state.message}</p>
                                </div>

                            </div>

                        </div>
                    </div>

                </GuestLayout>

            );
        } else {
            return null;
        }
    }
}

VerifyLinkAccount.propTypes = {};

const getAccountInfoError = selectErrorMessage(['ACCOUNT_INFO']);

const mapStateToProps = (state) => {

    const isLoggedIn = selectAuth(state).isLoggedIn,
        accountId = selectAuth(state).accountId,
        accountInfo = selectAccountInfo(state).accountInfo,
        accountInfoError = getAccountInfoError(state),
        userConfiguration = getUser(state).configuration;
    return {
        isLoggedIn,
        accountId,
        accountInfo,
        accountInfoError,
        userConfiguration
    };
};

const mapDispatchToProps = {
    verifyLinkedAccountsRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyLinkAccount);
